export { OPENSTACK_MODULE } from './openstack.module';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/openstack/src/index.ts